export enum IAddToMarketListButtonVariant {
  DEFAULT = "default",
  ADDED = "added",
}

export interface IAddToMarketListButton {
  variant: IAddToMarketListButtonVariant;
  className?: string;
  onClick: () => void;
  isLoading: boolean;
  addText: string;
  addedText?: string;
  removeText: string;
  showIconOnRight?: boolean;
}
